import script from "./ReviewShow.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewShow.vue?vue&type=script&setup=true&lang=js"

import "./ReviewShow.vue?vue&type=style&index=0&id=659a1a14&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-659a1a14"]])

export default __exports__